<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <domain-table></domain-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import domainTable from './DomainTable.vue'

  export default {
    name: 'domain',
    components: {domainTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/domain/Domain.vue